import { Icons, List, ListItemButton, ListItemDecorator } from '@healthinal/ui';
import { createLink, Link, useLocation } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ListItemButtonWrapper = forwardRef<HTMLAnchorElement, Record<string, unknown>>(
  function ListItemButtonWrapper(props, ref) {
    return <ListItemButton ref={ref} component={Link} {...props} />;
  },
);
const ListItemButtonLink = createLink(ListItemButtonWrapper);

export function PersonSideNavigation({ personId }: { personId: string }) {
  const pathname = useLocation({ select: (location) => location.pathname });
  const personalienPath = `/masterdata/persons/${personId}`;
  const historyPath = `/masterdata/persons/${personId}/history`;
  const documentPath = `/masterdata/persons/${personId}/document`;
  const isPersonalienActive = pathname === personalienPath || pathname === `${personalienPath}/`;
  const isHistoryActive = pathname === historyPath;
  const isDocumentActive = pathname === documentPath;

  return (
    <List sx={{ maxWidth: 208, p: 0, '--ListItem-radius': '8px', textDecoration: 'none' }}>
      <ListItemButtonLink
        to="/masterdata/persons/$personId"
        params={{ personId }}
        replace
        variant={isPersonalienActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.AccountCircle />
        </ListItemDecorator>
        Personalien
      </ListItemButtonLink>
      <ListItemButtonLink
        to="/masterdata/persons/$personId/history"
        params={{ personId }}
        replace
        variant={isHistoryActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.History />
        </ListItemDecorator>
        Verlauf
      </ListItemButtonLink>
      <ListItemButtonLink
        to="/masterdata/persons/$personId/document"
        params={{ personId }}
        replace
        variant={isDocumentActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.Description />
        </ListItemDecorator>
        Dokumente
      </ListItemButtonLink>
    </List>
  );
}
